module.exports = __webpack_public_path__ + "img/lose.ef3cecce.png";